import { useMutation, useQueryClient } from '@tanstack/react-query';
import { formBuilderApi, formBuilderKeys } from '@/features/quote-and-apply-builder';

export function useDeleteForm() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (formId: string) => formBuilderApi.deleteForm(formId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: formBuilderKeys.lists() });
      queryClient.invalidateQueries({ queryKey: formBuilderKeys.details() });
    },
  });
}
